import { InputText } from '@ui/src';
import { CardItemLimitsFormTypes } from '../types';

import cn from '../styles.module.css';

const CardItemLimitsForm = ({ setLimits, limits }: CardItemLimitsFormTypes) => (
  <>
    <div className={cn.orderCardFormGroup}>
      <InputText
        name="perMonth"
        placeholder="Per month limits"
        onChange={(e) => setLimits({ ...limits, perMonth: e.target.value })}
        value={limits.perMonth}
        title="Per Month"
      />
    </div>
    <div className={cn.orderCardFormGroup}>
      <InputText
        name="perWeek"
        placeholder="Per week limits"
        onChange={(e) => setLimits({ ...limits, perWeek: e.target.value })}
        value={limits.perWeek}
        title="Per Week"
      />
    </div>
    <div className={cn.orderCardFormGroup}>
      <InputText
        name="indefinitely"
        placeholder="Indefinitely limits"
        onChange={(e) => setLimits({ ...limits, indefinitely: e.target.value })}
        value={limits.indefinitely}
        title="Indefinitely"
      />
    </div>
  </>
);

export default CardItemLimitsForm;
